import { Type, plainToInstance } from 'class-transformer'
import { FolderPath } from '@core/entities/folders/FolderResponse'
import { Entity } from '@core/entities/entity'
import { User } from '@core/entities/user'
import { ProcoreDocumentVersionBase } from '@core/entities/ProcoreDocumentVersionBase'
import { IProcoreDocument } from './IProcoreDocument'

export class ProcoreDocument extends Entity<IProcoreDocument> {
  id: number
  name: string

  @Type(() => User)
  modifiedBy: User

  modifiedOn: string

  @Type(() => User)
  createdBy: User

  createdOn: string

  folder: {
    folderId: number
    pathFromRoot: FolderPath
  }

  @Type(() => ProcoreDocumentVersionBase)
  currentVersion?: ProcoreDocumentVersionBase

  public static new(payload: IProcoreDocument) {
    const entity = plainToInstance(ProcoreDocument, payload)

    return entity
  }
}
